{
  "accountHealth": "Hesap Sağlığı",
  "activeCopies": "Aktif Kopyalar",
  "addFavorite": "Favorilere Ekle",
  "affectedCoins": "Etkilenen Coinler",
  "aiAlert": "AI Uyarısı",
  "aiArbitrageScanner": "AI Arbitraj Tarayıcı",
  "aiCenter": "AI Merkezi",
  "aiConfidence": "AI Güveni",
  "aiConfidenceMeter": "AI Güven Göstergesi",
  "aiCopyTrading": "AI Kopya Alım Satım",
  "aiFinalDecision": "AI Nihai Kararı",
  "aiGridTrading": "AI Grid İşlem",
  "aiLaunchpad": "AI Launchpad",
  "aiMarketNews": "AI Piyasa Haberleri",
  "aiMarketScanner": "AI Piyasa Tarayıcı",
  "aiNews": "AI Haberler",
  "aiPortfolioManager": "AI Portföy Yöneticisi",
  "aiProfitCalculator": "AI Kâr Hesaplayıcı",
  "aiRankedTrader": "AI Sıralamalı Yatırımcı",
  "aiRebalance": "AI Yeniden Dengeleme",
  "aiRecommendation": "AI Tavsiyesi",
  "aiRecommendations": "AI Önerileri",
  "aiResult": "AI Sonucu",
  "aiRiskEngine": "AI Risk Motoru",
  "aiRiskLevel": "AI Risk Seviyesi",
  "aiRiskManager": "AI Risk Yöneticisi",
  "aiScanResult": "AI Tarama Sonucu",
  "aiScore": "AI Skoru",
  "aiSignal": "AI Sinyali",
  "aiSmartAlerts": "AI Akıllı Uyarılar",
  "aiSubtitle": "AI destekli alım satım, analiz, otomasyon ve risk yönetimi.",
  "aiSuggestions": "AI Önerileri",
  "aiTitle": "Yapay Zeka",
  "aiTrader": "AI Yatırımcı",
  "aiTradingAssistant": "AI İşlem Asistanı",
  "aiTradingAssistantSubtitle": "Gerçek zamanlı AI piyasa sinyalleri, duygu ve trend analizi.",
  "aiTrustScore": "AI Güven Skoru",
  "aiWhaleAlerts": "AI Balina Uyarıları",
  "aiWhaleHeatmap": "AI Balina Isı Haritası",
  "aiWhaleTracker": "AI Balina Takibi",
  "alertType": "Uyarı Türü",
  "allCategories": "Tüm Kategoriler",
  "allImpact": "Tüm Etkiler",
  "allImpacts": "Tüm Etkiler",
  "allSentiments": "Tüm Duygu Durumları",
  "allSymbols": "Tüm Semboller",
  "apply": "Uygula",
  "applySafeModeScan": "Güvenli Mod Taramasını Uygula",
  "applying": "Uygulanıyor...",
  "arbitrageOpportunities": "Arbitraj Fırsatları",
  "assetAllocation": "Varlık Dağılımı",
  "audit": "Denetim",
  "backendPreviewAlerts": "Uyarılar kaydedilmeden önce burada önizlenir.",
  "backendWillSaveAfterApi": "Bu, sunucu isteği onayladıktan sonra kaydedilecektir.",
  "baseCoin": "Taban Coin",
  "breaking": "Son Dakika",
  "btcDominance": "BTC Dominansı",
  "btcVolatilityNews": "BTC Oynaklık Haberleri",
  "buyDecision": "Al",
  "buyExchange": "Alım Borsası",
  "buyPressure": "Alım Baskısı",
  "buyPrice": "Alış Fiyatı",
  "buySignal": "Al",
  "buyStrength": "Alım Gücü",
  "buyVolume": "Alım Hacmi",
  "buyZone": "Alım Bölgesi",
  "calculate": "Hesapla",
  "calculateAiProfit": "AI Kârını Hesapla",
  "calculating": "Hesaplanıyor...",
  "capitalGreaterThanZero": "Sermaye sıfırdan büyük olmalıdır.",
  "capitalProtection": "Sermaye Koruması",
  "category": "Kategori",
  "clear": "Temizle",
  "communityScore": "Topluluk Skoru",
  "compoundDays": "Bileşik Gün Sayısı",
  "compoundResult": "Bileşik Sonuç",
  "condition": "Koşul",
  "confidence": "Güven",
  "confidenceScore": "Güven Skoru",
  "contractSafety": "Kontrat Güvenliği",
  "copyTradeIdMissing": "Kopya işlem ID'si eksik.",
  "copyTrader": "Kopya Yatırımcı",
  "copyTradingStarted": "Kopya alım satım başlatıldı.",
  "copyTradingStopped": "Kopya alım satım durduruldu.",
  "createAiAlert": "AI Uyarısı Oluştur",
  "createAiOpportunity": "AI Fırsatı Oluştur",
  "createAiWhaleAlert": "AI Balina Uyarısı Oluştur",
  "createGridStrategy": "Grid Stratejisi Oluştur",
  "createLaunchpadProject": "Launchpad Projesi Oluştur",
  "createOpportunity": "Fırsat Oluştur",
  "createSmartAlert": "Akıllı Uyarı Oluştur",
  "createWhaleAlert": "Balina Uyarısı Oluştur",
  "created": "Oluşturuldu",
  "creating": "Oluşturuluyor...",
  "currentPrice": "Güncel Fiyat",
  "currentRiskScore": "Mevcut Risk Skoru",
  "dailyProfit": "Günlük Kâr",
  "delete": "Sil",
  "deleteCalculationConfirm": "Bu hesaplamayı silmek istediğinizden emin misiniz?",
  "deleteMarketScanConfirm": "Bu piyasa taramasını silmek istediğinizden emin misiniz?",
  "detected": "Tespit Edildi",
  "diversification": "Çeşitlendirme",
  "emailAlert": "E-posta Uyarısı",
  "enableCompoundingProjection": "Bileşik Getiri Projeksiyonunu Etkinleştir",
  "enterCopyAmountFor": "Şunun için kopya tutarı girin:",
  "enterNewsTitle": "Haber başlığını girin",
  "exitPrice": "Çıkış Fiyatı",
  "expectedLoss": "Beklenen Zarar",
  "expectedProfit": "Beklenen Kâr",
  "extremeFear": "Aşırı Korku",
  "extremeGreed": "Aşırı Açgözlülük",
  "failedCalculateProfit": "Kâr hesaplanamadı.",
  "failedCreateArbitrageOpportunity": "Arbitraj fırsatı oluşturulamadı.",
  "failedCreateGridStrategy": "Grid stratejisi oluşturulamadı.",
  "failedCreateLaunchpadProject": "Launchpad projesi oluşturulamadı.",
  "failedCreateSmartAlert": "Akıllı uyarı oluşturulamadı.",
  "failedDeleteCalculation": "Hesaplama silinemedi.",
  "failedDeleteMarketScan": "Piyasa taraması silinemedi.",
  "failedLoadAiNews": "AI haberleri yüklenemedi.",
  "failedLoadArbitrageScanner": "Arbitraj tarayıcı yüklenemedi.",
  "failedLoadGridTrading": "Grid işlem yüklenemedi.",
  "failedLoadLaunchpad": "Launchpad yüklenemedi.",
  "failedLoadMarketScanner": "Piyasa tarayıcı yüklenemedi.",
  "failedLoadProfitCalculator": "Kâr hesaplayıcı yüklenemedi.",
  "failedLoadRiskManager": "Risk yöneticisi yüklenemedi.",
  "failedLoadSmartAlerts": "Akıllı uyarılar yüklenemedi.",
  "failedLoadTrustScore": "Güven skoru yüklenemedi.",
  "failedLoadWhaleHeatmap": "Balina ısı haritası yüklenemedi.",
  "failedLoadWhaleTracker": "Balina takibi yüklenemedi.",
  "failedLogins": "Başarısız Girişler",
  "failedMarkAlertRead": "Uyarı okundu olarak işaretlenemedi.",
  "failedNewsAction": "Bu işlem tamamlanamadı.",
  "failedRefreshRiskProfile": "Risk profili yenilenemedi.",
  "failedRunMarketScan": "Piyasa taraması çalıştırılamadı.",
  "failedStartCopyTrading": "Kopya alım satım başlatılamadı.",
  "failedStopCopyTrading": "Kopya alım satım durdurulamadı.",
  "failedSubmitNews": "Haber gönderilemedi.",
  "failedSyncSymbol": "Sembol senkronize edilemedi.",
  "failedToLoadData": "AI verileri yüklenemedi.",
  "failedUpdateFavorite": "Favori güncellenemedi.",
  "favorite": "Favori",
  "fear": "Korku",
  "fearGreedGauge": "Korku ve Açgözlülük Göstergesi",
  "fearGreedIndex": "Korku & Açgözlülük Endeksi",
  "featuredLaunch": "Öne Çıkan Lansman",
  "generate": "Oluştur",
  "generateAiGrid": "AI Grid Oluştur",
  "generating": "Oluşturuluyor...",
  "greed": "Açgözlülük",
  "gridCount": "Grid Sayısı",
  "gridStrategies": "Grid Stratejileri",
  "grids": "Gridler",
  "hardCap": "Sert Tavan",
  "heat": "Isı",
  "high": "Yüksek",
  "highPriority": "Yüksek Öncelik",
  "highRisk": "Yüksek Risk",
  "highRiskDetected": "Yüksek risk tespit edildi.",
  "highWithdrawals": "Yüksek Para Çekimleri",
  "holderScore": "Sahiplik Skoru",
  "impact": "Etki",
  "investment": "Yatırım",
  "kycCompleted": "KYC Tamamlandı",
  "lastScan": "Son Tarama",
  "lastUpdated": "Son Güncelleme",
  "latestAlert": "En Son Uyarı",
  "launchpadProjects": "Launchpad Projeleri",
  "liquidityScore": "Likidite Skoru",
  "liveAiMarketSignal": "Canlı AI Piyasa Sinyali",
  "liveVolume": "Canlı Hacim",
  "liveWhaleAlerts": "Canlı Balina Uyarıları",
  "loading": "Yükleniyor...",
  "loadingAi": "AI verileri yükleniyor...",
  "loadingAiNews": "AI Haberleri yükleniyor...",
  "loadingArbitrageScanner": "Arbitraj Tarayıcı yükleniyor...",
  "loadingGridTrading": "Grid İşlem yükleniyor...",
  "loadingLaunchpad": "Launchpad yükleniyor...",
  "loadingMarketScanner": "Piyasa Tarayıcı yükleniyor...",
  "loadingProfitCalculator": "Kâr Hesaplayıcı yükleniyor...",
  "loadingRiskManager": "Risk Yöneticisi yükleniyor...",
  "loadingSmartAlerts": "Akıllı Uyarılar yükleniyor...",
  "loadingTrustScore": "Güven Skoru yükleniyor...",
  "loadingWhaleAlerts": "Balina Uyarıları yükleniyor...",
  "loadingWhaleHeatmap": "Balina Isı Haritası yükleniyor...",
  "loadingWhaleTracker": "Balina Takibi yükleniyor...",
  "lowRisk": "Düşük Risk",
  "lowRiskDetected": "Düşük risk tespit edildi.",
  "lowerPrice": "Alt Fiyat",
  "markRead": "Okundu Olarak İşaretle",
  "marketSentiment": "Piyasa Duygusu",
  "marketType": "Piyasa Türü",
  "marketWeaknessDetected": "Piyasa zayıflığı tespit edildi.",
  "maxBuy": "Maksimum Alım",
  "medium": "Orta",
  "mediumRisk": "Orta Risk",
  "mediumRiskDetected": "Orta düzey risk tespit edildi.",
  "minBuy": "Minimum Alım",
  "minimumWhaleAmountUsd": "Minimum Balina Tutarı (USD)",
  "moderateTrend": "Ilımlı Trend",
  "monthlyProfit": "Aylık Kâr",
  "myCopyTrades": "Kopya İşlemlerim",
  "myMarketScanHistory": "Piyasa Tarama Geçmişim",
  "myProfitHistory": "Kâr Geçmişim",
  "neutralDecision": "Nötr",
  "neutralMarketConditions": "Nötr piyasa koşulları.",
  "neutralSignal": "Nötr",
  "newsFeed": "Haber Akışı",
  "noActiveCopyTrades": "Aktif kopya işlem yok.",
  "noAiNewsFound": "AI haberi bulunamadı.",
  "noAlertsFound": "Uyarı bulunamadı.",
  "noCalculationYet": "Henüz hesaplama yok.",
  "noDate": "Tarih yok",
  "noGridStrategiesFound": "Grid stratejisi bulunamadı.",
  "noHeatmapDataFound": "Isı haritası verisi bulunamadı.",
  "noLaunchpadProjectsFound": "Launchpad projesi bulunamadı.",
  "noOpportunitiesFound": "Fırsat bulunamadı.",
  "noPinnedNews": "Sabitlenmiş haber yok.",
  "noRecommendationYet": "Henüz öneri yok.",
  "noRiskHistoryYet": "Henüz risk geçmişi yok.",
  "noSavedCalculations": "Kayıtlı hesaplama yok.",
  "noSavedScans": "Kayıtlı tarama yok.",
  "noScanYet": "Henüz tarama yok.",
  "noTrustScoresFound": "Güven skoru bulunamadı.",
  "noWhaleTransactionsFound": "Balina işlemi bulunamadı.",
  "noWhaleWalletsDetected": "Balina cüzdanı tespit edilmedi.",
  "notScannedYet": "Henüz taranmadı.",
  "p2pDisputes": "P2P İtirazları",
  "pinned": "Sabitlendi",
  "pinnedNews": "Sabitlenmiş Haberler",
  "portfolioExposure": "Portföy Riski",
  "portfolioRebalancedSuccessfully": "Portföy başarıyla yeniden dengelendi.",
  "position": "Pozisyon",
  "priority": "Öncelik",
  "processing": "İşleniyor...",
  "projectName": "Proje Adı",
  "raised": "Toplanan",
  "raisedAmount": "Toplanan Tutar",
  "rebalanceFailed": "Yeniden dengeleme başarısız oldu.",
  "records": "Kayıtlar",
  "refresh": "Yenile",
  "refreshAiScan": "AI Taramasını Yenile",
  "risk": "Risk",
  "riskFactors": "Risk Faktörleri",
  "riskHistory": "Risk Geçmişi",
  "riskLevel": "Risk Seviyesi",
  "riskReward": "Risk / Ödül",
  "riskRewardRatio": "Risk/Ödül Oranı",
  "riskScore": "Risk Skoru",
  "roi": "Yatırım Getirisi (ROI)",
  "runAiMarketScan": "AI Piyasa Taraması Çalıştır",
  "runAiScan": "AI Taraması Çalıştır",
  "safe": "Güvenli",
  "scan": "Tara",
  "scanning": "Taranıyor...",
  "searchAiNews": "AI haberlerinde ara...",
  "searchWalletOrSymbol": "Cüzdan veya sembol ara...",
  "sellDecision": "Sat",
  "sellExchange": "Satış Borsası",
  "sellPressure": "Satım Baskısı",
  "sellPrice": "Satış Fiyatı",
  "sellSignal": "Sat",
  "sellVolume": "Satış Hacmi",
  "sellZone": "Satım Bölgesi",
  "serverError": "Sunucu hatası.",
  "sessionExpired": "Oturum süresi doldu. Lütfen tekrar giriş yapın.",
  "signal": "Sinyal",
  "signalStrength": "Sinyal Gücü",
  "smartAlerts": "Akıllı Uyarılar",
  "softCap": "Soft Cap",
  "source": "Kaynak",
  "sourceUrl": "Kaynak URL",
  "spread": "Spread",
  "stop": "Durdur",
  "strongBuyDecision": "Güçlü Al",
  "strongBuyOpportunity": "Güçlü alım fırsatı.",
  "strongTrend": "Güçlü Trend",
  "submitAiNews": "AI Haberi Gönder",
  "submitNews": "Haber Gönder",
  "submitNewsForAiAnalysis": "AI analizi için haber gönderin.",
  "suggestedCopy": "Önerilen Kopya Tutarı",
  "suggestedLeverage": "Önerilen Kaldıraç",
  "summary": "Özet",
  "suspiciousActivity": "Şüpheli Etkinlik",
  "sync": "Senkronize Et",
  "syncing": "Senkronize ediliyor...",
  "targetPrice": "Hedef Fiyat",
  "telegramAlert": "Telegram Uyarısı",
  "timeframe": "Zaman Dilimi",
  "title": "Başlık",
  "titleSummaryRequired": "Başlık ve özet zorunludur.",
  "tokenPrice": "Token Fiyatı",
  "topGainers": "En Çok Yükselenler",
  "topGridStrategy": "En İyi Grid Stratejisi",
  "topLosers": "En Çok Düşenler",
  "topOpportunity": "En İyi Fırsat",
  "topWhaleWallets": "En Büyük Balina Cüzdanları",
  "totalAlerts": "Toplam Uyarı",
  "totalCopied": "Toplam Kopyalanan",
  "totalNews": "Toplam Haber",
  "totalPL": "Toplam K/Z",
  "totalValue": "Toplam Değer",
  "totalWhaleVolume": "Toplam Balina Hacmi",
  "tradeSetup": "İşlem Kurulumu",
  "transferVolume": "Transfer Hacmi",
  "trend": "Trend",
  "trendStrength": "Trend Gücü",
  "upperPrice": "Üst Fiyat",
  "usdValue": "USD Değeri",
  "viewDetails": "Detayları Görüntüle",
  "volatility": "Oynaklık",
  "volatilityIndex": "Oynaklık Endeksi",
  "weakTrend": "Zayıf Trend",
  "whaleAccumulation": "Balina Birikimi",
  "whaleActivity": "Balina Etkinliği",
  "whaleAlertCreatedFor": "Balina uyarısı oluşturuldu:",
  "whaleRisk": "Balina Riski",
  "whaleScore": "Balina Skoru",
  "writeNewsSummary": "Haber özeti yazın",
  "yearlyProfit": "Yıllık Kâr"
}